import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Icon, List, ListItem, ListItemIcon, ListItemText, Paper, PaperProps } from '@mui/material';
import { IRespFluxoValidacao } from 'shared/types/workflows';
import Draggable from 'react-draggable';

interface IValidaModal {
  open: boolean;
  respValidacao: IRespFluxoValidacao;
  onClose: () => void;
}

const getIcon = (componente:string) => {
  if(componente === 'inicio')
    return (<Icon >play_circle</Icon>);
  if(componente === 'fim')
    return (<Icon >stop_cicle</Icon>);
  if(componente === 'campanha')
    return (<Icon >campaign</Icon>);
  if(componente === 'condicional')
    return (<Icon >question_mark</Icon>);
  if(componente === 'sleep')
    return (<Icon >timer</Icon>);

};

const PaperComponent = (props: PaperProps) => {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
};

export const ValidacaoModal: React.FC<IValidaModal> = ({
  open,
  respValidacao,
  onClose
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
    >
      <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">{`${respValidacao.resultado} - ${respValidacao.descricao}`}</DialogTitle>
      {respValidacao.erros && (<DialogContent>
        <List sx={{ pt: 0 }}>
          {respValidacao.erros.map((erro, index) => (
            <ListItem key={index}>
              <ListItemIcon>{getIcon(erro.tipoComponente)}</ListItemIcon>
              <ListItemText 
                primary={erro.nomeComponente}
                secondary={erro.dsErro} />
            </ListItem>
          ))}

        </List>
      </DialogContent>)}
      <DialogActions>
        <Button
          color='primary'
          variant='contained'
          onClick={onClose}
        >
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
};